var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedots3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33341 0.0820312C1.41675 0.0820312 0.666748 0.832031 0.666748 1.7487C0.666748 2.66536 1.41675 3.41536 2.33341 3.41536C3.25008 3.41536 4.00008 2.66536 4.00008 1.7487C4.00008 0.832031 3.25008 0.0820312 2.33341 0.0820312ZM2.33341 11.7487C1.41675 11.7487 0.666748 12.4987 0.666748 13.4154C0.666748 14.332 1.41675 15.082 2.33341 15.082C3.25008 15.082 4.00008 14.332 4.00008 13.4154C4.00008 12.4987 3.25008 11.7487 2.33341 11.7487ZM2.33341 5.91537C1.41675 5.91537 0.666748 6.66537 0.666748 7.58203C0.666748 8.4987 1.41675 9.2487 2.33341 9.2487C3.25008 9.2487 4.00008 8.4987 4.00008 7.58203C4.00008 6.66537 3.25008 5.91537 2.33341 5.91537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots3);
export default __webpack_public_path__ + "static/media/threedots3.d3fea532f70c5ec29a5390d1b6d67e3c.svg";
export { ForwardRef as ReactComponent };